import { defineQuery } from 'next-sanity'
import { z } from 'zod'

import { DEFAULT_LOCALE } from '../../../domain/constants'
import { coalesceLocalizedValue } from '../../utils'
import { GET_IMAGE_FRAGMENT, ImageSchema } from '../common/getImage.fragment'
import { LINK_FRAGMENT, LinkSchema } from './link.fragment'

export const MenuCardSchema = z.object({
  image: ImageSchema,
  pageLink: LinkSchema,
})

export type MenuCard = z.infer<typeof MenuCardSchema>

export const MENU_CARD_FRAGMENT = (locale = DEFAULT_LOCALE) =>
  defineQuery(`
    ${coalesceLocalizedValue(
      'localizedMenuCard',
      locale,
      'image',
      `.image {
        // Only include image if the linked page is shown in the current locale
        ^.pageLink->page->showInLocales[$locale] != false => {
          ${GET_IMAGE_FRAGMENT()}
        }
      }`,
    )},
    ${coalesceLocalizedValue(
      'localizedMenuCard',
      locale,
      'pageLink',
      `.pageLink-> {
        // Only include link if the linked page is shown in the current locale
        page->showInLocales[$locale] != false => {
          ${LINK_FRAGMENT(locale)}
        }
      }`,
    )}
`)
